import httpHelper from "@/helpers/httpHelper";
// action types
export const CREATE_GOALLINK = "createGoalLink";

// mutation types
// export const SET_GOALLINK = "setGoalLink";


export default {
    state: {
        // goalLinks: {},
       
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        // loadedWallets(state) {
        //     return state.wallets;
        // },

    },
    actions: {
        /**
         * Set the create goal link list
         * @param state
         * @param payload
         */
        [CREATE_GOALLINK](commit,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .postData('goal-link',payload)
                .then((response) => {
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        
    },
    mutations: {
        // [SET_DETAILS_SHARING](state, payload) {
        //     state.detailsSharing = [...state.detailsSharing, payload];
        // },
        // [SET_WALLETS](state, payload) {
        //     console.log("payload mutation:",payload);
        //     state.wallets = payload;
        // },
       
    }
};